import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import { SortablePaletteField } from "./sortable-palette-field";
import { Field } from "@/services/entity-view.service";
import { cn } from "@/lib/utils";

export interface DroppablePaletteProps {
  availableFields: Field[];
  isHovered: boolean;
  isDraggingAny: boolean;
}

export function DroppablePalette({
  availableFields,
  isHovered,
  isDraggingAny,
}: DroppablePaletteProps) {
  const { setNodeRef } = useDroppable({
    id: "palette",
    data: { isPalette: true },
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm font-medium">Available Fields</CardTitle>
      </CardHeader>
      <CardContent>
        <div
          ref={setNodeRef}
          className={cn("transition-all duration-200", {
            "-m-2 rounded border border-green-200 bg-green-50 p-2": isHovered,
            "opacity-75": isDraggingAny,
          })}
        >
          <SortableContext
            items={availableFields.map((f) => f.id)}
            strategy={verticalListSortingStrategy}
          >
            <div className="space-y-2">
              {availableFields.map((field) => (
                <SortablePaletteField key={field.id} field={field} />
              ))}
            </div>
          </SortableContext>
          {availableFields.length === 0 && (
            <div className="py-8 text-center text-gray-500">
              <div className="text-sm">All fields are in use</div>
              <div className="mt-1 text-xs">Drag fields back here to reuse them</div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
